const eventType = {
  en: {
    AMERICAN_FOOTBALL: "American Football",
    ATHLETICS: "Athletics",
    AUSTRALIAN_RULES: "Australian Rules",
    BASEBALL: "Baseball",
    BASKETBALL: "Basketball",
    BOXING: "Boxing",
    CHESS: "Chess",
    CRICKET: "Cricket",
    CYCLING: "Cycling",
    DARTS: "Darts",
    ELECTION: "Election",
    ESPORTS: "E-Sports",
    FANCYBET: "FancyBet",
    FINANCIAL_BETS: "Financial Bets",
    GAELIC_GAMES: "Gaelic Games",
    GOLF: "Golf",
    GREYHOUND_RACING: "Greyhound Racing",
    HORSE_RACING: "Horse Racing",
    ICE_HOCKEY: "Ice Hockey",
    MIXED_MARTIAL_ARTS: "Mixed Martial Arts",
    MOTOR_SPORT: "Motor Sport",
    NETBALL: "Netball",
    POKER: "Poker",
    POLITICS: "Politics",
    RUGBY_LEAGUE: "Rugby League",
    RUGBY_UNION: "Rugby Union",
    SNOOKER: "Snooker",
    SOCCER: "Soccer",
    TENNIS: "Tennis",
    KABADDI: "Kabaddi",
    E_SOCCER: "E-Soccer",
    VIRTUAL_CRICKET: "Virtual Cricket"
  },
  cn: {
    AMERICAN_FOOTBALL: "美式足球",
    ATHLETICS: "田径",
    AUSTRALIAN_RULES: "Australian Rules",
    BASEBALL: "棒球",
    BASKETBALL: "篮球",
    BOXING: "拳击",
    CHESS: "西洋棋",
    CRICKET: "板球",
    CYCLING: "自行车赛",
    DARTS: "飞镖",
    ELECTION: "选举",
    ESPORTS: "电玩竞赛",
    FANCYBET: "FancyBet",
    FINANCIAL_BETS: "金融投注",
    GAELIC_GAMES: "盖尔运动",
    GOLF: "高尔夫球",
    GREYHOUND_RACING: "赛狗",
    HORSE_RACING: "赛马",
    ICE_HOCKEY: "冰球",
    MIXED_MARTIAL_ARTS: "混合武术",
    MOTOR_SPORT: "摩多车赛",
    NETBALL: "英式篮球",
    POKER: "扑克",
    POLITICS: "政治",
    RUGBY_LEAGUE: "橄榄球",
    RUGBY_UNION: "橄榄球联盟",
    SNOOKER: "桌球",
    SOCCER: "足球",
    TENNIS: "网球",
    KABADDI: "卡巴迪",
    E_SOCCER: "电子足球",
    VIRTUAL_CRICKET: "虚拟板球"
  }
}

export default eventType
